import React from "react";

import { Dialog } from 'primereact/dialog';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Button } from 'primereact/button';
import { Badge } from 'primereact/badge';
import { ProgressSpinner } from 'primereact/progressspinner';

import Card from 'react-bootstrap/Card';

import UserContext from '../context/UserContext';


class ControlTaskDialog extends React.Component {

	static contextType = UserContext;

	state = {
		isLoading: false,
		controlTask: {
			comments:[],
		},
	};


	componentDidMount() {
		if (this.props.taskID && this.props.taskID !== 0) {
			this.fetchTaskDetails(this.props.taskID);
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevProps.taskID !== this.props.taskID && this.props.taskID !== 0) {
			this.fetchTaskDetails(this.props.taskID);
		}
	}


	fetchTaskDetails(taskID) {
		this.setState({ isLoading: true });
		fetch(`api/ControlTest/GetTestTask/` + taskID, { method: 'GET', headers: { 'Content-Type': 'application/json' } })
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.error) {
					throw (data.error);
				}
				this.setState({ controlTask: data });
				this.setState({ isLoading: false });
			})
			.catch(error => {
				this.setState({ isLoading: false });
			})
	}

	closeDialog() {
		if (this.props.onClose != null) {		
			this.props.onClose();
		}
	}

	render() {
		
		
		const footerContent = (
			<div>
				<Button label="Close" icon="pi pi-times" onClick={() => this.closeDialog()} className="p-button-secondary" disabled={this.state.isLoading} />			
			</div>
		);

		return (
			<Dialog header={this.state.controlTask.name}
				visible={this.props.visible}
				style={{ width: '75vw', height: '75vh', overflow: 'hidden' }}
				footer={footerContent}
				modal contentStyle={{ height: '300px' }}
				closable={true}
				onHide={() => { this.closeDialog() }}
			>

				<ConfirmDialog />

				<div style={{ flexWrap: 'wrap', display: 'flex', width: '100%', flexDirection: 'row', flexBasis: 'auto' }}>
					<Card className='rounded' style={{ width: '49%', minWidth: '20rem', marginRight: '2%', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Task details</b>
						</Card.Header>
						<Card.Body>
							<b>Description</b>
							<div>{this.state.controlTask.description}</div><br />
							<b>WorkFlow</b>
							<div>{this.state.controlTask.workFlow}</div><br />
							<b>Responsible role</b>
							<div>{this.state.controlTask.responsible}</div>
						</Card.Body>
					</Card>

					<Card className='rounded' style={{ width: '49%', minWidth: '20rem', marginBottom: '1.5rem' }}>
						<Card.Header>
							<b>Closing details</b>
						</Card.Header>
						<Card.Body>
							<b>Closer</b>
							<div>{this.state.controlTask.closer}</div><br />
							<b>Status</b>
							<div>{this.state.controlTask.status}</div><br />
							<b>Sceduled start</b>
							<div>{this.state.controlTask.scheduledDate?this.state.controlTask.scheduledDate.split('T')[0]:null}</div>
							<b>Actual start</b>
							<div>{this.state.controlTask.startTime ? this.state.controlTask.startTime.split('T')[0] :null}</div>
							<b>Sceduled deadline</b>
							<div>{this.state.controlTask.deadline ? this.state.controlTask.deadline.split('T')[0] :null}</div>
							<b>Actual Closing</b>
							<div>{this.state.controlTask.closeTime ? this.state.controlTask.closeTime.split('T')[0] :null}</div>
						</Card.Body>
					</Card>
				</div>

				{this.state.controlTask.comments.map((value, index) => {
					return (
						<Card bg='light' className='mb-2' key={'cmt' + index}>
							<Card.Header>
								<div style={{ float: 'left' }}>
									<b>{value.type}</b> by {value.poster}
								</div>
								<div style={{ float: 'right' }}>
									{value.postDate.split('T')[0]}
								</div>
								
							</Card.Header>
							<Card.Body>
								<Card.Text>
									{value.text}
								</Card.Text>
							</Card.Body>
						</Card>
					)
				})}
				
			</Dialog>
		);
	}
}
export default (ControlTaskDialog);
